import React from "react";
import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";
import { Paper, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { formatCurrency } from "../../hooks/Currency";

const PurchaseAndSellChart = (props) => {
  const { t } = useTranslation();
  const _store = useSelector((state) => state.pos.defStore);

  const { sellsPerMonth, purchPerMonth } = props;

  const options = {
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },

    xaxis: {
      categories: [
        t("jan"),
        t("feb"),
        t("mar"),
        t("apr"),
        t("may"),
        t("jun"),
        t("jul"),
        t("aug"),
        t("sep"),
        t("oct"),
        t("nov"),
        t("dec"),
      ],
    },

    yaxis: {
      title: {
        text: t("totalSales"),
        style: {
          color: "var(--gray-color)",
          fontFamily: "roboto",
        },
      },
      labels: {
        formatter: (val) => formatCurrency(val, _store),
        style: {
          fontSize: "14px",
        },
      },
    },

    tooltip: {
      y: {
        formatter: (val) => formatCurrency(val, _store),
      },
    },

    fill: {
      opacity: 1,
    },
  };


  const series = [
    {
      name: t("sales"),
      data: sellsPerMonth,
    },
    {
      name: t("purchase"),
      data: purchPerMonth,
    },
  ];

  return (
    <Paper className="shadow-xs p-15 br-6">
      {/* Chart */}
      <Typography variant="h6" className="fs-18 fw-5 gray-color mb-10">
        {t("purchaseAndSalesReports")}
      </Typography>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        width="100%"
        height="300"
      />
    </Paper>
  );
};

export default PurchaseAndSellChart;
